'use client';

interface ToggleSwitchProps {
    checked: boolean;
    disabled?: boolean;
    onChange: () => void;
    dataTestId?: string;
}

// TODO: Import ToggleSwitch from shared-ui and this component will be removed
export function ToggleSwitch({ checked, disabled = false, onChange, dataTestId }: ToggleSwitchProps) {
    return (
        <label 
            className={`relative inline-block w-[50px] h-[30px] ${disabled ? 'opacity-40' : ''}`}
            data-testid={dataTestId}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={disabled ? undefined : onChange}
                disabled={disabled}
                className="opacity-0 w-0 h-0"
            />
            <span 
                className={`
                    absolute cursor-pointer inset-0 rounded-[15px] transition-all duration-400
                    ${checked ? 'bg-[#77ba3f]' : 'bg-[#ccc]'}
                `}
            />
            <span 
                className={`
                    absolute h-7 w-7 left-[1px] bottom-[1px] bg-white rounded-full transition-all duration-400
                    ${checked ? 'translate-x-5' : 'translate-x-0'}
                `}
            />
        </label>
    );
}

export default ToggleSwitch;
